import React from 'react'
import InputWithLabel from '../../../../../../components/inputWithLabel';

const NPS = ({ data, handleAnswer, answers }) => {

    const selectedAns = answers?.[data?.refCode];
    const numberCount = selectedAns?.split(" + ")[0] ?? "";
    const inputText = selectedAns?.split(" + ")[1] ?? "";
    const filename = selectedAns?.split(" + ")[2] ?? "";
    const url = selectedAns?.split(" + ")[3] ?? "";

    const handleChangeNumber = (e) => {
        const { value } = e?.target;
        // if(Number(value) < -100 || Number(value) > 100) return;
        handleAnswer(`${value} + ${inputText ?? ""} + ${filename ? filename : "didn't upload attachment"}${url ? " + " + url : ""}`);
    }
    const handleChangeText = (e) => {
        handleAnswer(`${numberCount} + ${e?.target?.value ?? ""} + ${filename ? filename : "didn't upload attachment"}${url ? " + " + url : ""}`);
    }

    return (
        <>
            <div className="options gap-4">
                <div>
                    <InputWithLabel min={-100} max={100} type={"number"} value={Number(numberCount) || ''} onChange={handleChangeNumber} labelFontWeight="500" label={"Please share your most recent NPS score. The score ranges from -100 to 100."} />
                </div>
                <div className='yes__text__comment'>
                    <p>Specify whether this score is for this specific location or your entire portfolio.</p>
                    <textarea
                        rows="5"
                        value={inputText}
                        onChange={handleChangeText}
                        required={true}
                    ></textarea>
                </div>
                {/* <Uploader
                    url={url}
                    filename={filename}
                    inputRef={inputRef}
                    handleFileUpload={handleFileUpload}
                    handleUpload={handleFileUpload}
                    handleDelete={handleDelete}
                    uploadLoading={uploadLoading}
                    data={data}
                /> */}
            </div>
        </>
    )
}

export default NPS;